import {memo, useEffect, useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {useParams} from 'react-router-dom'
import DatePickerV2 from '../../../components/DatePickerV2/DatePickerV2'
import {Selection} from '../../../components/Selection'
import {TRowFilter} from '../../../components/Table/Table'
import {TextInputV2} from '../../../components/TextInputV2'
import {REGARDING_OPTIONS, SECTOR_OPTIONS} from '../../../constants'
import {useSalesOrganization} from '../../../hooks/useSalesOrganization'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {initialState, setFilter, sipSelector} from '../../../redux/slices/sipSlices'
import {useSIPStatus} from 'src/hooks/useSIPStatus'
import { hasFilterProps } from './helpers'

export const RowFilter = () => {
  const {t} = useTranslation()
  const {filter} = useAppSelector(sipSelector)
  const dispatch = useAppDispatch()
  const params = useParams()
  const {salesOrgOptions} = useSalesOrganization()
  const optionStatus = useSIPStatus()

  const hideFilterStatus = useMemo(() => {
    return params.type === 'reject' || params.type === 'amandement' || params.type === 'revision'
  }, [params.type])

  const handleChange = (value: Partial<typeof filter>) => {
    dispatch(setFilter({...filter, ...value}))
  }

  useEffect(() => {
    let filter = initialState.filter
    try{
      let persisted = JSON.parse(localStorage.getItem('redux-sip-filter') as string)
      if(hasFilterProps(persisted)){
        filter = {
          ...filter,
          ...persisted
        }
      }
    }catch(e){}

    if (params.type === 'outstanding') {
      handleChange({...filter, status: '', outstanding_data: 'true'})
      return
    }
    if (params.type === 'revision') {
      handleChange({...filter, status: '2', outstanding_data: 'false'})
      return
    }
    if (params.type === 'reject') {
      handleChange({...filter, status: '99', outstanding_data: 'false'})
      return
    }
    if (params.type === 'amandement') {
      handleChange({...filter, status: '91', outstanding_data: 'false'})
      return
    }
    handleChange({...filter, status: '', outstanding_data: 'false'})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params])

  return (
    <TRowFilter>
      <td>
        <TextInputV2
          placeholder={t('No. SIP')}
          value={filter?.SIP_number ?? ''}
          onChange={({target}) => handleChange({SIP_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('order-no')}
          value={filter?.po_number ?? ''}
          onChange={({target}) => handleChange({po_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('order-pelanggan')}
          value={filter?.customer_name ?? ''}
          onChange={({target}) => handleChange({customer_name: target.value})}
        />
      </td>
      <td>
        <Selection
          data={REGARDING_OPTIONS}
          placeholder={t('order-perihal')}
          value={filter?.perihal ?? ''}
          onChange={(perihal) => handleChange({perihal})}
        />
      </td>
      <td>
        <Selection
          data={SECTOR_OPTIONS}
          placeholder={t('Sektor')}
          value={filter?.sector_id ?? ''}
          onChange={(sector_id) => handleChange({sector_id})}
        />
      </td>
      <td>
        <Selection
          data={salesOrgOptions}
          placeholder='Sales Org'
          value={filter?.sales_org_code ?? ''}
          onChange={(sales_org_code) => handleChange({sales_org_code})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('order-tanggal')}
          isSelectsRange={false}
          startDate={filter?.created_at ?? ''}
          onChange={({startDate}) => handleChange({created_at: startDate})}
        />
      </td>
      <td>
        <DatePickerV2
          isSelectsRange={false}
          placeholder={t('Tanggal Pengajuan')}
          startDate={filter?.estimate_date ?? ''}
          onChange={({startDate}) => handleChange({estimate_date: startDate})}
        />
      </td>
      <td>
        <DatePickerV2
          isSelectsRange={false}
          placeholder={t('Start-Date')}
          startDate={filter?.from_date ?? ''}
          onChange={({startDate}) => handleChange({from_date: startDate})}
        />
      </td>
      <td>
        <DatePickerV2
          isSelectsRange={false}
          placeholder={t('End-Date')}
          startDate={filter?.to_date ?? ''}
          onChange={({startDate}) => handleChange({to_date: startDate})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Total Kuantum')}
          value={filter?.total_quantum}
          onChange={({target}) => handleChange({total_quantum: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Total Price')}
          value={filter?.total_request_price ?? ''}
          onChange={({target}) => handleChange({total_request_price: target.value})}
        />
      </td>
      <td>
        {!hideFilterStatus && (
          <Selection
            data={optionStatus}
            placeholder={'Status'}
            value={filter?.status?.toString() ?? ''}
            onChange={(status) => handleChange({status})}
          />
        )}
      </td>
      <td>
        <div>&nbsp;</div>
      </td>
    </TRowFilter>
  )
}

export default memo(RowFilter)
